export default class UserCalendarsState {

  static getLoadingState = () => {
    return new UserCalendarsState(null, null, true, null)
  }

  static getLoadingErrorState = error => {
    return new UserCalendarsState(null, null, false, error)
  }

  static getLoadedCalendarsState = (imported, userCalendars) => {
    return new UserCalendarsState(imported, userCalendars, false, null)
  }

  static getNullState = () => {
    return new UserCalendarsState()
  }

  constructor(importedCalendars, userCalendars, loading, loadingError) {
    this.importedCalendars = importedCalendars
    this.userCalendars = userCalendars
    this.loading = loading
    this.loadingError = loadingError
    this.checked = {}
  }

  getCalendarSummary = id => {
    const calendar = this.userCalendars && this.userCalendars.find(calendar => calendar.id === id)
    return calendar && calendar.summary
  }

  updateImportedCalendars = importedCalendars => {
    this.importedCalendars = importedCalendars
  }

  toggleLoading = value => {
    this.loading = value
  }
  
  isLoading = () => this.loading

  hasError = () => Boolean(this.loadingError)

  getError = () => this.loadingError

  getUserCalendars = () => this.userCalendars

  getImportedCalendars = () => {
    if (!this.importedCalendars) {
      return null
    }
    const result = []
    for (const key in this.importedCalendars) {
      const imported = this.importedCalendars[key]
      const userCalendar = this.userCalendars && this.userCalendars.find(calendar => calendar.id === imported.id)
      if (userCalendar) {
        result.push(userCalendar)
      }
    }
    return result
  }

  isImported = id => Boolean(Object
    .keys(this.importedCalendars)
    .find(key => this.importedCalendars[key].id === id))

  isChecked = id => this.isImported(id) || Boolean(this.checked[id])

  toggleCalendarCheck = id => {
    if (this.checked[id]) {
      delete this.checked[id]
    }
    else {
      this.checked[id] = true
    }
  }

  /**
   * Return the calendars that are selected to import, those are non previously imported.
   */
  selectedForImport = () => {
    return this.userCalendars.filter(calendar => this.checked[calendar.id] && !this.isImported(calendar.id))
  }

}



// WEBPACK FOOTER //
// ./src/schedule/gcal/UserCalendarsState.js